import { v4 as uuidv4 } from "uuid";

/**
 * UUID type with the standard UUID format (8-4-4-4-12 hexadecimal digits)
 * Example: "123e4567-e89b-12d3-a456-426614174000"
 */
export type UUID = `${string}-${string}-${string}-${string}-${string}`;

/**
 * Generates a random UUID v4
 *
 * Note: This uses the uuid library instead of the Web Crypto API because
 * crypto.randomUUID() is not available in Safari when running on HTTP
 * (only HTTPS or localhost). This is a limitation during local development
 * when accessing the app via HTTP on local network IPs (e.g., 192.168.x.x).
 *
 * @returns A randomly generated UUID v4 string
 */
export function generateUUID(): UUID {
  return uuidv4() as UUID;
}
